import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)


const store = new Vuex.Store({

    state:{
        login_status: false,
		access_token: "",
		nickname:"未登录",
		avatar:'',
		friend_list:[],
		message_list:[]
    },
    mutations:{
		Logout(state)
		{
			state.login_status 	= false;
			state.access_token 	= "";
			state.nickname 		= "未登录";
			state.avatar 		= '';
			localStorage.setItem('storeData', JSON.stringify(state));
			console.log("Logout");
		},
		loginSuccess(state, payload)
		{
			state.login_status = true;
			state.access_token = payload.access_token;
			state.nickname 	   = payload.userinfo.nickname;
			state.avatar 	   = payload.userinfo.avatar;
			localStorage.setItem("access_token", state.access_token);
			localStorage.setItem('storeData', JSON.stringify(state));
		},
		// 持久化数据，恢复到内存中
		recoverState(state)
		{
			let data = localStorage.getItem('storeData');
			if(data)
			{
				let data_json = JSON.parse(data);
				if(data_json)
				{
					state.avatar 	    = data_json.avatar;
					state.login_status 	= data_json.login_status;
					state.access_token 	= data_json.access_token;
					state.nickname 		= data_json.nickname;
					localStorage.setItem("access_token", state.access_token);
				}
			}
		}
    },
    actions:{
		initData(){
			
		}
    }


})

export default store
